/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-lonely-if */
/* eslint-disable  @typescript-eslint/no-use-before-define */

import React, { FC, useCallback, useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { useDispatch, useSelector } from 'react-redux';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';
import Modal from '@salesforce/design-system-react/components/modal';
import OrdersHeader from '../OrdersHeader';
import { GET_CASE_USAGE_SHEET_LIST } from '../../../graphql/getCaseUsageSheetList';
import { GET_CASE_USAGE_SHEET_REVIEW_LIST } from '../../../graphql/getCaseUsageSheetReviewList';
import {
  API,
  LIMIT,
  NEXT_DATA,
  NOTIFY_TYPE,
  ORDER_SCREEN_TYPE,
  ORDER_TYPE,
  PO_DISPLAY,
  PO_FILTER_VALUES,
  PREV_DATA,
  SHOW_AGENCY_RECORDS,
  SHOW_STRYKER_RECORDS,
} from '../../../util/constants';
import debounced from '../../../util/debounced';
import { getSurgeonDisplayName } from '../../../util/surgeonDisplayName';
import '../index.scss';
import FilterTags from '../../Shared/FilterTags';
import { getUserId } from '../../../store/ducks/userId';
import { GET_FILTER_PRESETS } from '../../../graphql/getFilterPresets';
import FilterOrders from '../FilterOrders';
import OrdersDataTable from '../OrderDataTable';
import {
  clearOrderFilters,
  getOrderFilter,
  setOrderFilters,
} from '../../../store/ducks/orderFilters';
import { GET_WORKFLOW_PERMISSIONS } from '../../../graphql/workflowPermissions';
import { getUserInfo } from '../../../store/ducks/userInfo';
import { openSnackBar } from '../../../store/ducks/snackBar';
import GENERATE_MULTIPLE_PDF from '../../../graphql/mutations/generateMultiplePdf';
import { getFormattedHoldReasons } from '../../../util/formatHoldReasons';

interface Props {
  type: string;
}

interface SelectedData {
  id: string;
  label: string;
  __typename?: string;
}
interface Filters {
  status: SelectedData[];
  salesReps: SelectedData[];
  coveringReps: SelectedData[];
  account: SelectedData[];
  branch: SelectedData[];
  franchise: SelectedData[];
  surgeon: SelectedData[];
  procedureDetail: SelectedData[];
  procedureType?: SelectedData[];
  startDate: Date | string;
  endDate: Date | string;
  usage: string;
  filterExternalId?: string;
  filterName?: string;
  search?: string;
  parentCaseExternalId?: string;
  parentCaseId?: string;
  parentEventStartDate?: string;
  parentEventId?: string;
  parentEventType?: string;
  parentEventStatus?: string;
}
interface FilterPreset {
  filterValues: Filters;
  filterExternalId?: string;
  filterName?: string;
}

interface DynamicValue {
  [key: string]: any;
}

const OrderRequests: FC<Props> = ({ type }) => {
  const [offset, setOffset] = useState(0);
  const [sortColumn, setSortColumn] = useState<any>();
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<DynamicValue | null>(null);
  const [selectedFilterApiValues, setSelectedFilterApiValues] = useState<DynamicValue | null>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [enableGenerate, setEnableGenerate] = useState(false);
  const [generatePdf, setGeneratePdf] = useState(false);
  const [requestId, setRequestId] = useState(0);
  const [generateMultiplePDF] = useMutation(GENERATE_MULTIPLE_PDF);

  const userInfo = useSelector(getUserInfo);
  const [isEditFilter, setIsEditFilter] = useState(false);
  const id = useSelector(getUserId);
  const { data: filterPresets, refetch: refetchFilterPresets } = useQuery(GET_FILTER_PRESETS, {
    variables: {
      userId: id,
      type: 'Orders',
    },
  });

  const [getOrdersList, { data: ordersList, loading: loadingOrderList }] = useLazyQuery(
    GET_CASE_USAGE_SHEET_LIST,
    {
      fetchPolicy: 'cache-and-network',
    }
  );
  const [
    getOrdersReviewList,
    { data: ordersReviewList, loading: loadingOrderReviewList, refetch },
  ] = useLazyQuery(GET_CASE_USAGE_SHEET_REVIEW_LIST, {
    fetchPolicy: 'cache-and-network',
  });
  useQuery(GET_WORKFLOW_PERMISSIONS);


  const handleEditPress = (filter: FilterPreset, isEditPress: boolean): void => {
    setSelectedFilter(filter);
    setFilterModalVisible(!filterModalVisible);
    if (isEditPress) {
      handleEditFilter(true);
    }
  };
  const filterPresetData = filterPresets?.getFilterPresets;
  const dispatch = useDispatch();
  useEffect(() => {
    if (type === ORDER_SCREEN_TYPE.REVIEW) {
      getOrdersReviewList({
        variables: {
          limit: LIMIT,
          offset: 0,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: selectedFilterApiValues,
        },
      });
    } else {
      getOrdersList({
        variables: {
          limit: LIMIT,
          offset: 0,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: selectedFilterApiValues,
        },
      });
    }
  }, [selectedFilterApiValues, type]);

  const getOrdersFromList = useCallback((items: any[]): any[] => {
    if (items && items.length > 0) {
      const isCustDetailsFilterActive = !!selectedFilterApiValues?.PO?.includes(
        PO_FILTER_VALUES.CUSTOMER_DETAILS_REQUIRED
      );

      return items.map((item: any) => {
        const hasPO = !!item.poNumber;
        const hasPOAttachment = !!item.poAttachmentTimestamp;
        const hasCustomerDetails =
          !!item.signatureTimestamp && !!item.hospitalPrintedName && !!item.customerTitle;

        // The BE already evaluates which orders are pending when this filter is active.
        // The field checks guard against false positives if multiple PO filter values are
        // sent to the BE (the PO filter is an array), ensuring the warning only appears
        // on orders that are actually missing a PO attachment or customer details.
        const poWarning =
          isCustDetailsFilterActive && (!hasPOAttachment || !hasCustomerDetails)
            ? PO_DISPLAY.CUSTOMER_DETAILS_PENDING
            : '';

        return {
          ...item,
          userHoldReasons: getFormattedHoldReasons(item.userHoldReasons),
          usageType: item.orderType === ORDER_TYPE.SJC_SM_BILL_ONLY ? 'Bill Only' : 'Ship & Bill',
          eventDateTime: item.eventDateTime ? moment.utc(item.eventDateTime).format('L') : null,
          account: `${item.accountNumber} - ${item.accountName}`,
          PO: hasPO ? item.poNumber : PO_DISPLAY.MISSING_PO,
          poWarning,
          procedureName: item.procedureName || '--',
          surgeon: getSurgeonDisplayName(item),
          totalAmount: item.totalAmount ? parseFloat(item.totalAmount).toFixed(2) : '0.00',
        };
      });
    }
    return [];
  }, [selectedFilterApiValues]);

  const ordersFromQuery = useMemo(() => {
    if (type === ORDER_SCREEN_TYPE.OPEN && ordersList?.getCaseUsageSheetList) {
      return getOrdersFromList(ordersList.getCaseUsageSheetList);
    }
    if (type === ORDER_SCREEN_TYPE.REVIEW && ordersReviewList?.getCaseUsageSheetListOps) {
      return getOrdersFromList(ordersReviewList.getCaseUsageSheetListOps);
    }
    return [];
  }, [ordersList, ordersReviewList, type, getOrdersFromList]);

  const orders = ordersFromQuery;

  const handleRefetchItems = useCallback(
    (filterData: Filters | DynamicValue | null): void => {
      setOffset(0);
      if (type === ORDER_SCREEN_TYPE.REVIEW) {
        getOrdersReviewList({
          variables: {
            offset: 0,
            limit: LIMIT,
            type: type.toUpperCase(),
            orderBy: undefined,
            orderSortType: undefined,
            filters: filterData,
          },
        });
      } else {
        getOrdersList({
          variables: {
            offset: 0,
            limit: LIMIT,
            type: type.toUpperCase(),
            orderBy: undefined,
            orderSortType: undefined,
            filters: filterData,
          },
        });
      }
    },
    [type]
  );
  const filterStore = useSelector(getOrderFilter);

  useEffect(() => {
    const setFilters = JSON.parse(filterStore || '{}');

    if (setFilters && setFilters.filterValues) {
      setSelectedFilter(setFilters);
      const filters = getFilterApiValue(setFilters.filterValues);
      setSelectedFilterApiValues(filters);
      handleRefetchItems(filters);
    }
  }, [filterStore, handleRefetchItems]);
  const handlePaginationButtonClicked = (nav: string): void => {
    let finalOffset;
    if (nav === NEXT_DATA) {
      finalOffset = offset + LIMIT;
    } else {
      finalOffset = offset - LIMIT;
    }
    
    const sortProperty = sortColumn?.property;
    const sortDirection = sortColumn?.sortDirection;
    const filters = selectedFilter ? getFilterApiValue(selectedFilter.filterValues) : null;
    
    if (type === ORDER_SCREEN_TYPE.REVIEW) {
      getOrdersReviewList({
        variables: {
          offset: finalOffset,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: sortProperty || undefined,
          orderSortType: sortDirection || undefined,
          filters,
        },
      });
    } else {
      getOrdersList({
        variables: {
          offset: finalOffset,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: sortProperty || undefined,
          orderSortType: sortDirection || undefined,
          filters,
        },
      });
    }
    
    setOffset(finalOffset);
  };
  const handleToggleFilterOrder = (): void => {
    handleEditFilter(false);
    setFilterModalVisible(!filterModalVisible);
  };
  const handleEditFilter = (editFilter: boolean): void => {
    setIsEditFilter(editFilter);
  };
  const resetFilters = useCallback((): void => {
    setSelectedFilter(null);
    dispatch(clearOrderFilters());
    setSelectedFilterApiValues(null);
    setOffset(0);
    if (type === ORDER_SCREEN_TYPE.REVIEW) {
      getOrdersReviewList({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: null,
        },
      });
    } else {
      getOrdersList({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: null,
        },
      });
    }
  }, [dispatch, type]);

  const getFilterApiValue = (filterValues: DynamicValue): DynamicValue => {
    let reducedFilterValues = {};
    if (filterValues) {
      Object.keys(filterValues).forEach((key: string) => {
        if (Array.isArray(filterValues[key])) {
          let values;
          if (key === 'orderType') {
            values = filterValues[key].map((item: SelectedData) => item.label);
          } else if (key === 'PO') {
            const poIds: string[] = filterValues[key].map((item: SelectedData) => item.id);
            if (poIds.length > 0) {
              reducedFilterValues = { ...reducedFilterValues, PO: poIds };
            }
            return;
          } else if (key === 'part') {
            values = filterValues[key]?.[0]?.id;
          } else {
            values = filterValues[key].map((item: SelectedData) => item.id);
          }
          if (values && values.length > 0) {
            reducedFilterValues = {
              ...reducedFilterValues,
              [key]: key === 'part' ? values : [...values],
            };
          }
        } else if (key === 'accountType' && filterValues[key]) {
          const accountTypeSelected =
            filterValues[key] === 'My Accounts' ? 'MyAccounts' : 'TBAAccounts';
          reducedFilterValues = { ...reducedFilterValues, [key]: accountTypeSelected };
        } else if (key === 'lotOrSerial') {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key]?.label };
        } else if (key !== '__typename' && filterValues[key]) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] };
        } else if (key === SHOW_AGENCY_RECORDS || key === SHOW_STRYKER_RECORDS) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] || false };
        }
      });
      const filterData = { ...reducedFilterValues };
      return filterData;
    }
    return {};
  };
  const handleFilterOrders = (filterValues: DynamicValue | null, filterName?: string): void => {
    const updatedFilterName = filterName || '';
    const filter = {
      filterValues,
      filterName: updatedFilterName,
    };
    setSelectedFilter(filter);
    if (filterValues) {
      const filters = getFilterApiValue(filterValues);
      setSelectedFilterApiValues(filters);
      dispatch(setOrderFilters(JSON.stringify(filter)));
      handleRefetchItems(filters);
    } else {
      resetFilters();
    }
  };
  const handleDeleteFilterPreset = (externalId: string): void => {
    const filterExternalId = selectedFilter ? selectedFilter.filterExternalId : null;
    if (filterExternalId && filterExternalId === externalId) {
      resetFilters();
    }
  };

  const sortedcolumn = (property: any): void => {
    setSortColumn(property);
  };

  useEffect(() => {
    if (sortColumn) {
      const queryFn = type === ORDER_SCREEN_TYPE.REVIEW ? getOrdersReviewList : getOrdersList;
      queryFn({
        variables: {
          limit: LIMIT,
          offset: 0,
          type: type.toUpperCase(),
          orderBy: sortColumn.property,
          orderSortType: sortColumn.sortDirection,
          filters: selectedFilterApiValues,
        },
      });
      setOffset(0);
    }
  }, [sortColumn]);

  const setRequestSearch = (searchedItem: string): void => {
    if (type === ORDER_SCREEN_TYPE.REVIEW) {
      getOrdersReviewList({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: {
            searchText: searchedItem,
            ...selectedFilterApiValues,
          },
        },
      });
    } else {
      getOrdersList({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: type.toUpperCase(),
          orderBy: undefined,
          orderSortType: undefined,
          filters: {
            searchText: searchedItem,
            ...selectedFilterApiValues,
          },
        },
      });
    }
  };

  const debouncedFetchRequestedItems = useCallback(debounced(500, setRequestSearch), [
    debounced,
    setRequestSearch,
  ]);

  const handleOrderSearch = useCallback(
    (_event: { persist: () => void }, searchedItem: any) => {
      const { value } = searchedItem;
      _event.persist();
      if (value && value.length >= 3) {
        debouncedFetchRequestedItems(value);
      } else {
        debouncedFetchRequestedItems('');
      }
    },
    [debouncedFetchRequestedItems]
  );

  const handleGeneratePdf = (): void => {
    const randomRequestId: any = Math.floor(Math.random() * (999999 - 100) + 100);
    setRequestId(randomRequestId.toString());
    const items: any = [];
    selectedRows.forEach((cases: any) => {
      items.push({
        salesRepId: userInfo?.id,
        caseId: cases.caseId,
        caseExternalId: cases.caseExternalId,
      });
    });
    const payload = {
      userId: userInfo?.id,
      requestId: randomRequestId.toString(),
      items,
    };
    generateMultiplePDF({
      variables: payload,
    }).catch(() => {
      openSnackBar(NOTIFY_TYPE.ERROR, 'Something went wrong. Please try again.');
    });
    setGeneratePdf(true);
  };

  const handleSelectedRows = (items: any): void => {
    setSelectedRows(items);
    const isSameAccounts = items?.every((accountId: any) => {
      return accountId.accountId === items[0].accountId;
    });
    if (items.length > 0 && items.length < 6 && isSameAccounts) {
      setEnableGenerate(true);
    } else {
      setEnableGenerate(false);
    }
  };

  const handleClosePdfModal = (): void => {
    setGeneratePdf(false);
  };

  return (
    <IconSettings iconPath="/icons">
      <>
        {filterModalVisible && (
          <FilterOrders
            handleToggleFilterOrder={handleToggleFilterOrder}
            filterModalVisible={filterModalVisible}
            selectedFilter={selectedFilter}
            refetchFilterPresets={refetchFilterPresets}
            handleFilterOrders={handleFilterOrders}
            resetFilters={resetFilters}
            type={type}
            handleClearFilter={handleDeleteFilterPreset}
            isEditFilter={isEditFilter}
          />
        )}
        <OrdersHeader
          label={type}
          handleToggleFilterOrder={handleToggleFilterOrder}
          handleOrderSearch={handleOrderSearch}
          handleGeneratePdf={handleGeneratePdf}
          enableGenerate={enableGenerate}
          filterPresets={filterPresetData}
          onEditPress={handleEditPress}
          handleFilterOrders={handleFilterOrders}
          resetFilters={resetFilters}
          selectedFilterApiValues={selectedFilterApiValues}
          totalFilterResult={orders.length}
        />
        {selectedFilter && selectedFilter.filterValues && !isEditFilter && (
          <FilterTags selectedFilter={selectedFilter} handleFilter={handleFilterOrders} />
        )}
        <div className="order-list-container">
          {(loadingOrderList || loadingOrderReviewList) && orders.length === 0 && (
            <Spinner
              size="large"
              variant="base"
              assistiveText={{ label: 'Loading...' }}
              key="spinner"
            />
          )}
          <OrdersDataTable
            isCsrUser
            sortedcolumn={sortedcolumn}
            getOrdersList={type === ORDER_SCREEN_TYPE.REVIEW ? getOrdersReviewList : getOrdersList}
            orders={orders || []}
            offset={offset}
            type={type}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            sortOrderList={() => {}} // Server-side sorting only; no-op to satisfy prop contract
            refetch={refetch}
            selectedFilterApiValues={selectedFilterApiValues}
            handleSelectedRows={handleSelectedRows}
          />
        </div>
        <div className="slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-top_medium">
          <div className="slds-col">
            <Button
              assistiveText={{ icon: 'Icon Bare Small' }}
              iconCategory="utility"
              iconName="chevronleft"
              iconSize="small"
              disabled={!(offset > 0)}
              iconVariant="bare"
              onClick={(): void => handlePaginationButtonClicked(PREV_DATA)}
              variant="icon"
            />
          </div>
          <div className="slds-col slds-p-left_medium slds-p-right_medium">
            <span>{`${offset + 1} - ${offset + LIMIT}`}</span>
          </div>
          <div className="slds-col">
            <Button
              assistiveText={{ icon: 'Icon Bare Small' }}
              iconCategory="utility"
              iconName="chevronright"
              iconSize="small"
              iconVariant="bare"
              disabled={
                type === ORDER_SCREEN_TYPE.REVIEW
                  ? ordersReviewList?.getCaseUsageSheetListOps?.length < 50
                  : ordersList?.getCaseUsageSheetList?.length < 50
              }
              onClick={(): void => handlePaginationButtonClicked(NEXT_DATA)}
              variant="icon"
            />
          </div>
          {generatePdf && (
            <Modal
              className="cancel-creation-modal default-modal_header default-modal_footer"
              isOpen={generatePdf}
              onRequestClose={handleClosePdfModal}
              ariaHideApp={false}
              footer={[
                <Button label="Dismiss" variant="brand" onClick={handleClosePdfModal} key="no" />,
              ]}
              heading="Generated PDF"
            >
              <div className="slds-text-align--center">
                <div>
                  <h2 className="slds-m-around--large ">
                    {`PDF(s) will be generated under Request ID 
                  ${requestId} 
                  after 10 mins.`}
                  </h2>
                  <h2>PDF(s) can be viewed from Orders menu, under Generated PDF tab.</h2>
                  <h2>
                    PDF(s) will be valid until next 8 hours.
                    <br />
                    Any changes made after submitting the generate PDF request will not be reflected
                    in the generated PDF.
                  </h2>
                  <br />
                </div>
              </div>
            </Modal>
          )}
        </div>
      </>
    </IconSettings>
  );
};

export default OrderRequests;
